module.exports = __webpack_public_path__ + "img/img_Intelligentdiagnosis_a.cfd5ec2f.png";